import { AppConfigModel } from "../abstract/app-config.model";

export class AccountEntryType extends AppConfigModel {

    static override CLASS_NAME: string = 'AccountEntryType';
}
